/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReferralDocumentExport200ResponseData
 */
export interface GetReferralDocumentExport200ResponseData {
    /**
     * 
     */
    status: GetReferralDocumentExport200ResponseDataStatusEnum;
    /**
     * 
     */
    download_url?: string;
}


/**
 * @export
 */
export const GetReferralDocumentExport200ResponseDataStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Ready: 'ready',
    Failed: 'failed',
} as const;
export type GetReferralDocumentExport200ResponseDataStatusEnum = typeof GetReferralDocumentExport200ResponseDataStatusEnum[keyof typeof GetReferralDocumentExport200ResponseDataStatusEnum];


/**
 * Check if a given object implements the GetReferralDocumentExport200ResponseData interface.
 */
export function instanceOfGetReferralDocumentExport200ResponseData(value: object): value is GetReferralDocumentExport200ResponseData {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function GetReferralDocumentExport200ResponseDataFromJSON(json: any): GetReferralDocumentExport200ResponseData {
    return GetReferralDocumentExport200ResponseDataFromJSONTyped(json, false);
}

export function GetReferralDocumentExport200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferralDocumentExport200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'download_url': json['download_url'] == null ? undefined : json['download_url'],
    };
}

export function GetReferralDocumentExport200ResponseDataToJSON(json: any): GetReferralDocumentExport200ResponseData {
    return GetReferralDocumentExport200ResponseDataToJSONTyped(json, false);
}

export function GetReferralDocumentExport200ResponseDataToJSONTyped(value?: GetReferralDocumentExport200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'download_url': value['download_url'],
    };
}

